<div id="footer" class="text-center white">
  <span style="border-right: 1px solid;margin: 0 7px 0 0; padding: 0 7px 0 0" class="white">
    {{ versione }}
  </span>
  <span class="white">© Copyright Regione Lombardia</span>
  <span class="hidden-xs white"> - tutti i diritti riservati</span>
  <nav *ngIf="showAssistenza" class="voci_navigazione" role="navigation">
    <a style="cursor: pointer" (click)="openMsgDialog()">Assistenza</a>
  </nav>
</div>
